export default "__VITE_ASSET__d7921787__"